import { useEffect } from 'react';

import { AmplitudeExperimentIds, AmplitudeExperimentsVariantIds } from '../AmplitudeExperiments';
import { useAmplitudeFeatureFlag } from './useAmplitudeExperiments';

/**
 * Do not use this function directly! Use the corresponding experiment's hooks.
 */
export const useAmplitudeExperimentBase = (
    featureFlagKey: AmplitudeExperimentIds,
    featureFlagVariant: AmplitudeExperimentsVariantIds[typeof featureFlagKey]
) => {
    const { isShowingFeature, trackFeatureFlag } = useAmplitudeFeatureFlag(featureFlagKey, featureFlagVariant);

    useEffect(() => {
        // Track exposure regardless of variant to ensure proper experiment analysis.
        // Return the cleanup so a re-run (e.g. the post-mount forceExperiment override) cancels any
        // exposure scheduled by the previous render before its 1s timer fires.
        return trackFeatureFlag();
    }, [featureFlagKey, featureFlagVariant, isShowingFeature, trackFeatureFlag]);

    return isShowingFeature;
};
